import { CardPane } from '@/card/card-viewer/card-pane';
import { MapContainer } from '@/map/map-viewer/map-container';
import { MapCardSplitPane } from '@/splitpane/mapcard-splitpane';

export function MapCardView() {
  return (
    <MapCardSplitPane>
      <MapContainer />
      <CardPane />
    </MapCardSplitPane>
  );
}
